import React from "react";

function HeadingTitle({ item }) {
  return (
    <h2
      className={`col-span-3 font-semibold text-2xl text-left w-full ${
        item?.firstElement ? "mt-0" : "mt-8"
      }`}
    >
      {item?.label}
    </h2>
  );
}

export default HeadingTitle;
